import {useState} from 'react'
import './contact.scss'
function Contact(){

    const [number, setNumber] = useState('')

    const showNumber = () => {
        
        number === '' ? setNumber('0668028697') : setNumber('');
    }
        
    return(
        <section id="contact">
          <h2 className="fs-40">Contact</h2>
          <article className="contact goContact">
            <a id="appelmoi" className="icone" onClick={showNumber}><img src="/img/icons/tel.svg"/><p>Par téléphone</p><p id="numero">{number}</p></a>
            <a href="mailto:philippe_genot@hotmail.fr?subject=J'ai vu ton CV en ligne" className="icone"><img src="/img/icons/mail.svg"/><p>Par mail</p></a>
          </article>
        </section>
    )
}
export default Contact